import React from 'react'
import Signups from './Signups'

function Signup() {
  return (
    <div>
        <Signups />
    </div>
  )
}

export default Signup